import * as React from "react";

import { constants } from "@common/_constants";
import { ErrorService, TelemetryService } from "@common/_services";
import { CreateLogger } from "@common/utils";
import ErrorUnhandled from "@pro/containers/Pages/ErrorUnhandled";

const logger = CreateLogger("RelodePro");

export class ErrorBoundry extends React.Component<
    any,
    { hasErrors: boolean; error: any }
> {
    constructor(props) {
        super(props);
        this.state = {
            hasErrors: false,
            error: undefined,
        };
    }

    componentDidMount() {
        logger.info(`version: ${constants.GlobalConfig.version}`, true);
        logger.info(`build date: ${constants.GlobalConfig.buildDate}`, true);
        logger.info(
            `api url: ${constants.Routing.Api.General.FILE_DELETE}`,
            true
        );

        TelemetryService.init();
        ErrorService.registerGlobalErrorHandler(this.handleError);

        window.addEventListener(
            "unhandledrejection",
            (e: PromiseRejectionEvent) => {
                //this.handleError(e);
                e.preventDefault();
            }
        );
    }

    componentDidCatch(error, info) {
        this.handleError(error, info);
    }

    handleError = (error, info?) => {
        try {
            if (!info) {
                info = { componentStack: "error outside of react." };
            }
            TelemetryService.trackException(error, "App.gatherError", {
                stack: info.componentStack,
            });
        } finally {
            this.setState({ hasErrors: true });
        }
    };

    render() {
        const { hasErrors, error } = this.state;
        const { children } = this.props;

        return hasErrors ? <ErrorUnhandled /> : children;
    }
}
